import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-delegate.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessDelegate';

class AgentBookingMailInprocessDelegateCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessDelegate implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessDelegateCtrl];
}

export default MODULE_NAME;
